
import { Link } from "react-router-dom";
import { Calendar, ExternalLink } from "lucide-react";
import { getCurrentWeekDates, getDayText } from "../../../../services/functions";

import { useQueryParam } from 'use-query-params';
import { WeekButton } from "./WeekButton";



export function Header() {
  const [active] = useQueryParam("date");

  const weekDates = getCurrentWeekDates();
  const nextWeekDates = getCurrentWeekDates(1);
  const dayLink = active ? `date=${active}` : "";
  return (
    <>
      <div className="w-full flex">
        <p className="flex gap-2 text-scale-500 font-semibold text-lg items-center w-full">
          <Link to={`/agenda?${dayLink}`} className="flex gap-2 items-center">
            <Calendar className="w-6 h-6" /> Agenda
          </Link>
          <Link to={`/agenda?${dayLink}`} className="flex gap-2 text-zinc-500 font-normal text-base items-center ml-auto  hover:border-b hover:border-scale-500 hover:text-scale-500">
            {getDayText(active)} <ExternalLink className="w-5 h-5" />
          </Link>
        </p>
      </div>
      <div className="flex items-center justify-center px-4">
        <div className="flex gap-1">
          {weekDates.map(date => <WeekButton date={date} />)}
        </div>
        <span className="w-[2px] h-1/2 flex-none  bg-zinc-400/50" />
        <div className="flex gap-1">
          {nextWeekDates.map(date => <WeekButton date={date} />)}
        </div>
      </div>
    </>
  );
}
